export const SESSION_STORAGE_KEYS = {
  solDashboardState: 'solDashboardState'
} as const;

export enum ReviewStatusText {
    NotResponded = 'Response due',
    WaitingForInformation = 'Waiting for information',
    InProgressQRM = 'In-review',
    NonSatisfactoryResponse = 'Needs attention',
    Closed = 'Meets policy expectations',
    NA = 'NA',
    Discard = 'Discard',
    NonCompliant = 'Does not meet policy expectations'
}

export const stats = [{
    'field': ['NOT_RESPONDED'],
    'label': ReviewStatusText.NotResponded,
    'class': "text-danger",
    'value': 0,
    'icon': 'deloitte-icon exclamation_mark_pos'
},
{
    'field': ['IN_PROGRESS_QRM', 'WAITING_FOR_INFORMATION'],
    'label': ReviewStatusText.InProgressQRM,
    'class': "text-muted",
    'value': 0,
    'icon': 'fa fa-pencil-square-o'
},
{
    'field': ['NON_SATISFACTORY_RESPONSE_RECEIVED'],
    'label': ReviewStatusText.NonSatisfactoryResponse,
    'class': "text-warning",
    'value': 0,
    'icon': 'fa fa-clock-o'
},
{
    'field': ['CLOSED'],
    'label': ReviewStatusText.Closed,
    'class': "text-success",
    'value': 0,
    'icon': 'deloitte-icon tick_pos'
},
{
    'field': ['NON_COMPLIANT'],
    'label': ReviewStatusText.NonCompliant,
    'class': "text-compliant",
    'value': 0,
    'icon': 'deloitte-icon circle_cross'
}];

export const statsCmp = [{
    'field': ['NOT_RESPONDED'],
    'label': "Not Responded",
    'class': "text-danger",
    'value': 0,
    'icon': 'deloitte-icon exclamation_mark_pos'
},
{
    'field': ['PAUSED'],
    'label': "Paused",
    'class': "text-muted",
    'value': 0,
    'icon': 'fa fa-pause-circle-o'
},
{
    'field': ['CLOSED'],
    'label': "Closed Complete",
    'class': "text-success",
    'value': 0,
    'icon': 'deloitte-icon tick_pos'
}]
export const statsFtm = [{
    'field': ['IN_PROGRESS_QRM', 'WAITING_FOR_INFORMATION'],
    'label': "Review in Progress",
    'class': "text-muted",
    'value': 0,
    'icon': 'fa fa-pencil-square-o'
},
{
    'field': ['NON_SATISFACTORY_RESPONSE_RECEIVED'],
    'label': "Non Compliant",
    'class': "text-danger",
    'value': 0,
    'icon': 'fa fa-clock-o'
},
{
    'field': ['CLOSED'],
    'label': "Compliant",
    'class': "text-success",
    'value': 0,
    'icon': 'deloitte-icon tick_pos'
}]

export function groupBy<T>(
  array: T[],
  keyOrFn: keyof T | ((item: T) => string | number)
): Record<string, T[]> {
  return array.reduce((result, item) => {
    // Determine the group key
    const key =
      typeof keyOrFn === 'function'
        ? keyOrFn(item)
        : (item[keyOrFn] as string | number);

    // Initialize group if not present
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
    return result;
  }, {} as Record<string, T[]>);
}
export function deepEqual(a: any, b: any): boolean {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((el, idx) => deepEqual(el, b[idx]));
  }
  if (typeof a === 'object' && typeof b === 'object') {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every(key => deepEqual(a[key], b[key]));
  }
  return false;
}
